import { login, loginCA } from '@/api/login'
import { getToken, setToken, setUserPageCode, setUserId, getLeaderFlag, setLeaderFlag, getUserAccount, setUserAccount, getUserAreaCode, setUserAreaCode, getUserAreaFlag, setUserAreaFlag, getUserLevel, setUserLevel, getUserOrg, setUserOrg, getModuleInfo, setModuleInfo } from '@/utils/auth'
const user = {
  state: {
    name: '',
    account: '',
    password: '',
    pageCode: '', // 用户访问渠道code,ex:整体，个险，银代，团体，续收,财务，运营
    careId: '',
    pathId: '',
    orgId: '',
    level: '',
    productType: '',
    leader: '',
    areaCode: '',
    areaFlag: '',
    modalFlag: 0, // 初始设置标识设置为0
    token: getToken(), // 用户token
    leadFlag: 0, // 领导标识
    ticket: '', // CA令牌
    ad: '',
    headerFlag: false,
    moduleInfo: []

  },
  mutations: {
    MODAL_GLAG: (state, type) => {
      state.modalFlag = type
    },
    // 用户名
    USER_SET_NAME: (state, type) => {
      state.name = type
    },
    // 账户
    USER_SET_ACCOUNT: (state, type) => {
      state.account = type
    },
    // 用户的机构id
    USER_SET_ORG: (state, type) => {
      state.orgId = type
    },
    // 用户的level
    USER_SET_LEVEL: (state, type) => {
      state.level = type
    },
    // 密码
    USER_SET_PASSWORD: (state, type) => {
      state.password = type
    },
    // 模块的code
    USER_SET_PAGE_CODE: (state, type) => {
      state.pageCode = type
    },
    // 模块的codeId
    USER_SET_PAGE_CODEID: (state, type) => {
      state.codeId = type
    },
    // 模块的url 级别文字路径描述
    USER_SET_PAGE_PATHID: (state, type) => {
      state.pathId = type
    },
    // 产品分析维度
    USER_SET_PRODUCT_TYPE: (state, type) => {
      state.productType = type
    },
    // 领导
    USER_SET_LEADER: (state, type) => {
      state.leader = type
    },
    // 大区标识
    USER_SET_AREA_CODE: (state, type) => {
      state.areaCode = type
    },
    // 区域编码
    USER_SET_AREA_FLAG: (state, type) => {
      state.areaFlag = type
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_LEADER_FLAG: (state, leadFlag) => {
      state.leadFlag = leadFlag
    },
    SET_TICKET: (state, ticket) => {
      state.ticket = ticket
    },
    SET_AD: (state, ad) => {
      state.ad = ad
    },
    SET_HEADER_FLAG: (state, headerFlag) => {
      state.headerFlag = headerFlag
    },
    SET_MODULE_INFO: (state, moduleInfo) => {
      state.moduleInfo = moduleInfo
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            let data = res.data
            if (data) {
              setUserId(data.userId)
              setToken(data.token)
              commit('SET_TOKEN', data.token)
              setLeaderFlag(data.leadFlag)
              commit('SET_LEADER_FLAG', data.leadFlag)
              setUserAccount(data.userAccount)
              commit('USER_SET_ACCOUNT', data.userAccount)
              setUserAreaCode(data.areaCode)
              commit('USER_SET_AREA_CODE', data.areaCode)
              setUserAreaFlag(data.areaFlag)
              commit('USER_SET_AREA_FLAG', data.areaFlag)
              setUserLevel(data.level)
              commit('USER_SET_LEVEL', data.level)
              setUserOrg(data.orgId)
              commit('USER_SET_ORG', data.orgId)
              if (userInfo.type && userInfo.type === 'ygkb' && data.pageCode && data.pageCode !== 'null') {
                // 员工看板来源
                setUserPageCode(data.pageCode)
                commit('USER_SET_PAGE_CODE', data.pageCode)
              } else {
                // 普通来源
                setUserPageCode('')
                commit('USER_SET_PAGE_CODE', '')
              }
              // 模块
              let moduleInfo = []
              data.moduleInfo.map(item => {
                moduleInfo.push(
                  {
                    pageCode: item.pageCode,
                    pageName: item.pageName
                  }
                )
              })
              setModuleInfo(JSON.stringify(moduleInfo))
              commit('SET_MODULE_INFO', moduleInfo)
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 刷新后重新将用户信息存入store
    GetInfo ({ commit }) {
      commit('SET_LEADER_FLAG', getLeaderFlag())
      commit('USER_SET_ACCOUNT', getUserAccount())
      commit('USER_SET_AREA_CODE', getUserAreaCode())
      commit('USER_SET_AREA_FLAG', getUserAreaFlag())
      commit('USER_SET_LEVEL', getUserLevel())
      commit('USER_SET_ORG', getUserOrg())
      commit('SET_MODULE_INFO', JSON.parse(getModuleInfo()))
    },

    // TODO 退出系统
    LogOut ({ commit, state }) {
      return new Promise((resolve) => {
        console.log('logOut')
        // commit('SET_TOKEN', '')
        // removeToken()
        // resolve()
      })
    },

    // 存储CA过来的数据
    saveCAInfo ({ commit }, info) {
      return new Promise((resolve, reject) => {
        commit('SET_TICKET', info.ticket)
        commit('SET_AD', info.ad)
        // CA令牌存在的时候清除掉本地token
        if (info.ticket !== undefined && info.ticket !== '' && info.ticket !== null) {
          // commit('SET_TOKEN', '')
          // removeToken()
        }
        resolve()
      })
    },
    // CA登录
    LoginCA ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginCA(userInfo).then(res => {
          let data = res.data
          if (data) {
            setUserId(data.userId)
            setToken(data.token)
            commit('SET_TOKEN', data.token)
            setLeaderFlag(data.leadFlag)
            commit('SET_LEADER_FLAG', data.leadFlag)
            setUserAccount(data.userAccount)
            commit('USER_SET_ACCOUNT', data.userAccount)
            setUserAreaCode(data.areaCode)
            commit('USER_SET_AREA_CODE', data.areaCode)
            setUserAreaFlag(data.areaFlag)
            commit('USER_SET_AREA_FLAG', data.areaFlag)
            setUserLevel(data.level)
            commit('USER_SET_LEVEL', data.level)
            setUserOrg(data.orgId)
            commit('USER_SET_ORG', data.orgId)
            if (userInfo.type && userInfo.type === 'ygkb' && data.pageCode && data.pageCode !== 'null') {
              // 员工看板来源
              setUserPageCode(data.pageCode)
              commit('USER_SET_PAGE_CODE', data.pageCode)
            } else {
              // 普通来源
              setUserPageCode('')
              commit('USER_SET_PAGE_CODE', '')
            }
            // 模块
            let moduleInfo = []
            data.moduleInfo.map(item => {
              moduleInfo.push(
                {
                  pageCode: item.pageCode,
                  pageName: item.pageName
                }
              )
            })
            setModuleInfo(JSON.stringify(moduleInfo))
            commit('SET_MODULE_INFO', moduleInfo)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js